

const ExamInstruction = () => {
  return (
    <div className="w-[70%] mx-auto mt-8 mb-10">
            <div className="bg-red-50 border border-red-200 rounded-2xl shadow-sm p-6 flex flex-col gap-4">
              <h2 className="text-xl font-semibold text-red-600 text-center">
                Important Exam Instructions
              </h2>

              <p className="text-base text-red-700 leading-relaxed text-center">
                To begin your test, click the 
              <span className="px-3 py-1 bg-primary text-white rounded-lg mx-1">
                Start Exam
              </span>
              button above.
              </p>

              <p className="text-base text-red-700 leading-relaxed text-center">
                To avoid missing the exam window, you must click the 
              <span className="px-3 py-1 bg-primary text-white rounded-lg mx-1">
                Start Exam
              </span>
                button at least 
              <span className="font-semibold underline px-2 uppercase">10 minutes before</span> 
                the actual exam time.
              </p>

              <div className="mt-2 text-center text-sm text-red-500 italic">
              Please read carefully — late entries may not be accepted.
              </div>
            </div>
          </div>
  )
}

export default ExamInstruction